module.exports = __webpack_public_path__ + "img/Collab.7d074cbe.svg";